import { UiElement } from '../ui/UiElement.js'

export class PlotlyBasicPlotConfig extends UiElement {
    constructor(graphDiv, data = [], layout = {}, config = {}) {
        super(graphDiv);
        //_.merge(this, Plotly);

        const dataVefDefault = [];
        const layoutVefDefault = {
            margin: {
                l: 60,
                r: 10,
                b: 50,
                t: 80,
                pad: 0
            },
        };
        const configVefDefault = {
            displayModeBar: true,
            displaylogo: false,
            responsive: true,
        };

        this.graphDiv = this.getElement();
        this.data = _.merge(dataVefDefault, data);
        this.layout = _.merge(layoutVefDefault, layout);
        this.config = _.merge(configVefDefault, config);

        this.graphDiv.classList.add("vef-plot");
    }

    dispose() {
        Plotly.purge(this.graphDiv);
        super.dispose();
    }
}


export class PlotlyVefPlotConfig extends PlotlyBasicPlotConfig {

    constructor(graphDiv, data = [], layout = {}, config = {}) {

        const dataMeasurementsDefault = [];

        const layoutMeasurementsDefault = {
            spikedistance: -1,
            xaxis: { showspikes: true, spikethickness: 2, autorange: true },
            yaxis: { showspikes: true, spikethickness: 2, autorange: true },
        };

        const configMeasurementsDefault = {
            modeBarButtonsToRemove: ["select2d", "lasso2d", "hoverClosestGl2d", "hoverClosestPie", "toggleHover", "sendDataToCloud", "toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian", "autoScale2d"],
        };

        const modeButton = new PlotlyChangeModeButton(data);

        const dataPreMerged = _.merge(dataMeasurementsDefault, data);
        const layoutPreMerged = _.merge(layoutMeasurementsDefault, layout);
        const configPreMerged = _.merge(modeButton.configDefault, configMeasurementsDefault, config);

        super(graphDiv, dataPreMerged, layoutPreMerged, configPreMerged);

        this.graphDiv.classList.add("vef-plot-measurements");

    }
}


class PlotlyChangeModeButton {
    constructor(data) {
        this.modeIndex = 0;
        this.plotModes = ["markers", "lines", "lines+markers"]

        for (let i = 0; i < data.length; ++i) {
            if (this.modeIndex >= this.plotModes.length) this.modeIndex = 0;
            data[i].mode = this.plotModes[this.modeIndex];
            data[i].type = "scattergl";
        }

        this.configDefault = {
            modeBarButtonsToAdd: [
                {
                    name: 'Change Mode',
                    icon: () => {
                        const icon = document.createElement("i");
                        icon.classList.add("fas", "fa-project-diagram");
                        return icon;
                    },
                    click: gd => {
                        this.modeIndex = (this.modeIndex + 1) % this.plotModes.length;
                        Plotly.restyle(gd, 'mode', this.plotModes[this.modeIndex])
                    }
                }
            ]
        };
    }
}


export class PlotlyFilterVefPlotConfig extends PlotlyVefPlotConfig {
    constructor(graphDiv, data = [], layout = {}, config = {}) {
        const dataMeasurementsDefault = [];
        const layoutMeasurementsDefault = {};
        const configMeasurementsDefault = {
            modeBarButtonsToRemove: ["lasso2d", "hoverClosestGl2d", "hoverClosestPie", "toggleHover", "sendDataToCloud", "toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian", "autoScale2d"],
        };

        const dataPreMerged = _.merge(dataMeasurementsDefault, data);
        const layoutPreMerged = _.merge(layoutMeasurementsDefault, layout);
        const configPreMerged = _.merge(configMeasurementsDefault, config);

        super(graphDiv, dataPreMerged, layoutPreMerged, configPreMerged);

        this.graphDiv.classList.add("vef-plot-filter");

    }

    filterData() {
        this.getElement().on('plotly_selected', function (eventData) {
            if (!eventData) return
            var x = [];
            var y = [];

            eventData.points.forEach(function (pt) {
                x.push(pt.x);
                y.push(pt.y);
            });
            console.log('selected', x, y);
        });
    }
}